const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZxyh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.2,133.9c2.9,4.1,8.5,5.1,12.7,2.4,4.2-2.7,5.5-8.3,2.9-12.6l41.2-30.7c3.3,3.4,8.7,3.9,12.5,1,.6-.5,1.1-1,1.6-1.6l38.9,32.2c-2.5,4-1.7,9.3,1.9,12.4,4.2,3.2,10.1,2.4,13.4-1.6,1.7-1.9,2.5-4.5,2.3-7-.2-2.6-1.4-4.9-3.4-6.6-3.7-3-9.1-2.8-12.6.5l-39.4-32.8c1.2-3.2.7-6.7-1.3-9.5-3.2-4.2-9.2-5-13.4-1.8-3.8,2.9-4.8,8.2-2.6,12.3l-40.8,30.8c-3.3-3.5-8.7-3.9-12.5-1-4.2,3.3-5,9.4-1.7,13.6h.3Z",
    style: {
      fill: "#465566"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,176c3,4,8.6,5.1,12.8,2.4,4.2-2.7,5.6-8.2,3.2-12.6l41.1-30.8c3.3,3.4,8.7,3.9,12.5,1,.6-.5,1.2-1,1.7-1.6l38.3,32.1c-2.6,4-1.8,9.3,1.9,12.4,4.2,3.3,10.3,2.7,13.6-1.4,1.7-1.9,2.5-4.5,2.3-7-.2-2.6-1.4-4.9-3.4-6.6-3.7-3-9.1-2.8-12.6.4l-39.4-32.8c1.3-3.1,1-6.6-.9-9.4-1.5-2.1-3.8-3.5-6.3-3.9s-5.1.2-7.2,1.8c-3.9,2.9-5,8.3-2.6,12.5l-40.8,30.8c-3.3-3.4-8.6-3.8-12.5-1-4.2,3.3-5.1,9.3-1.8,13.6h.1Z",
    style: {
      fill: "#465566"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.8,123.6c-3-4-8.6-5-12.8-2.3s-5.7,8.2-3.4,12.6l-40.8,30.8c-3.3-3.4-8.7-3.9-12.5-1-.6.5-1.1,1-1.6,1.6l-38.7-32.2c2.6-4,1.8-9.3-1.9-12.4-4.2-3.3-10.3-2.6-13.6,1.6-3.2,4-2.7,9.7,1,13.1,3.6,3.1,9,3.1,12.6,0l39.4,32.8c-1.2,3.2-.7,6.7,1.3,9.4,3,4,8.6,5.1,12.8,2.4,4.2-2.7,5.6-8.2,3.2-12.6l40.8-30.8c3.3,3.4,8.6,3.8,12.5,1,2.1-1.6,3.6-4,3.9-6.6.3-2.6-.4-5.3-2.1-7.4h0Z",
    style: {
      fill: "#465566"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.8,165.7c-2.9-4.4-8.7-5.6-13.1-2.8-4.4,2.8-5.8,8.6-3.1,13.1l-40.8,30.8c-3.3-3.4-8.7-3.9-12.5-1-.6.5-1.1,1-1.6,1.6l-38.7-32.2c2.6-4,1.8-9.3-1.9-12.4-4.2-3.3-10.3-2.7-13.6,1.4-1.7,1.9-2.5,4.5-2.3,7,.2,2.6,1.4,4.9,3.4,6.6,3.7,3,9.1,2.8,12.6-.4l39.3,32.8c-1.2,3.2-.7,6.7,1.3,9.4,3,4,8.6,5.1,12.8,2.4,4.2-2.7,5.6-8.2,3.2-12.6l40.8-30.8c3.3,3.4,8.7,3.9,12.5,1,2.1-1.6,3.4-4,3.8-6.6.3-2.6-.4-5.2-2-7.3h0Z",
    style: {
      fill: "#465566"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 149.8,
    r: 128.1,
    style: {
      fill: "none",
      stroke: "#024dc4",
      strokeDasharray: 10,
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149,44.8c-11.2,0-20.4-9.1-20.4-20.4s9.1-20.4,20.4-20.4,20.4,9.1,20.4,20.4-9.1,20.4-20.4,20.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,8c9,0,16.4,7.4,16.4,16.4s-7.4,16.4-16.4,16.4-16.4-7.4-16.4-16.4,7.4-16.4,16.4-16.4M149,0c-13.5,0-24.4,10.9-24.4,24.4s10.9,24.4,24.4,24.4,24.4-10.9,24.4-24.4S162.5,0,149,0h0Z",
    style: {
      fill: "#024dc4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149,296c-11.2,0-20.4-9.1-20.4-20.4s9.1-20.4,20.4-20.4,20.4,9.1,20.4,20.4-9.1,20.4-20.4,20.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,259.2c9,0,16.4,7.4,16.4,16.4s-7.4,16.4-16.4,16.4-16.4-7.4-16.4-16.4,7.4-16.4,16.4-16.4M149,251.2c-13.5,0-24.4,10.9-24.4,24.4s10.9,24.4,24.4,24.4,24.4-10.9,24.4-24.4-10.9-24.4-24.4-24.4h0Z",
    style: {
      fill: "#024dc4"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.4,170.2c-11.2,0-20.4-9.1-20.4-20.4s9.1-20.4,20.4-20.4,20.4,9.1,20.4,20.4-9.1,20.4-20.4,20.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4,133.4c9,0,16.4,7.4,16.4,16.4s-7.4,16.4-16.4,16.4-16.4-7.4-16.4-16.4,7.4-16.4,16.4-16.4M24.4,125.4c-13.5,0-24.4,10.9-24.4,24.4s10.9,24.4,24.4,24.4,24.4-10.9,24.4-24.4-10.9-24.4-24.4-24.4h0Z",
    style: {
      fill: "#024dc4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.6,170.2c-11.2,0-20.4-9.1-20.4-20.4s9.1-20.4,20.4-20.4,20.4,9.1,20.4,20.4-9.1,20.4-20.4,20.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.6,133.4c9,0,16.4,7.4,16.4,16.4s-7.4,16.4-16.4,16.4-16.4-7.4-16.4-16.4,7.4-16.4,16.4-16.4M275.6,125.4c-13.5,0-24.4,10.9-24.4,24.4s10.9,24.4,24.4,24.4,24.4-10.9,24.4-24.4-10.9-24.4-24.4-24.4h0Z",
    style: {
      fill: "#024dc4"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 150.1,
    cy: 87,
    r: 10.8,
    style: {
      fill: "#ff4e00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 128.1,
    r: 10.8,
    style: {
      fill: "#ff4e00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.3,
    cy: 129.4,
    r: 10.8,
    style: {
      fill: "#ff4e00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.3,
    cy: 171.5,
    r: 10.8,
    style: {
      fill: "#ff4e00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.9,
    cy: 171.5,
    r: 10.8,
    style: {
      fill: "#ff4e00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.9,
    cy: 213.8,
    r: 10.8,
    style: {
      fill: "#ff4e00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.2,
    cy: 171.1,
    r: 10.8,
    style: {
      fill: "#ff4e00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.2,
    cy: 128.1,
    r: 10.8,
    style: {
      fill: "#ff4e00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.3,
    cy: 129.4,
    r: 6.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.3,
    cy: 171.5,
    r: 6.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.9,
    cy: 171.5,
    r: 6.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.2,
    cy: 171.1,
    r: 6.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.9,
    cy: 213.8,
    r: 6.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 128.1,
    r: 6.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.2,
    cy: 128.1,
    r: 6.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.1,
    cy: 87,
    r: 6.9,
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZxyh);
export default __webpack_public_path__ + "static/media/zxyh.093764e0a1de976414f131538f105805.svg";
export { ForwardRef as ReactComponent };